import React from 'react';

export const AuthContext = React.createContext({
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  login: async () => {},
  logout: () => {},
  refresh: async () => {},
  getToken: () => null,
});

export default AuthContext;


